module.exports = __webpack_public_path__ + "static/media/square_logo.c0dab6df.svg";